import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

const setLeftOffset = (offset) => css`
  left: ${offset}px;
`;

const StyledBox = styled(Box)`
  position: absolute;
  left: 0px;
  ${(props) => props.leftOffset && setLeftOffset(props.leftOffset)};
`;

const PillContainer = ({ children, leftOffset = 0 }) => (
  <StyledBox top={['-20px', null, '-22px']} leftOffset={leftOffset}>
    {children}
  </StyledBox>
);

PillContainer.propTypes = {
  children: PropTypes.node.isRequired,
  leftOffset: PropTypes.number,
};

export default PillContainer;
